import { render, staticRenderFns } from "./budget-category.vue?vue&type=template&id=7105987a&scoped=true"
import script from "./budget-category.vue?vue&type=script&lang=js"
export * from "./budget-category.vue?vue&type=script&lang=js"
import style0 from "./budget-category.vue?vue&type=style&index=0&id=7105987a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7105987a",
  null
  
)

export default component.exports